export default import.meta.ROLLDOWN_FILE_URL_u7K$ajvLf3eL0A5ibt$nLA